const Data = [
  {
    name: "Navya Sammeta",
    position: "Media and Publicity Head",
    imageUrl: "/assets/images/members/Heads26/NavyaSammeta.jpeg",
    facebookLink: "https://www.facebook.com/navya.sammeta.1",
    email: "navya.24@kgpian.iitkgp.ac.in",
    linkedinLink: "http://www.linkedin.com/in/navya-sammeta-b66724326"
  },
  {
    name: "Anjan Kumar",
    position: "Media and Publicity Head",
    imageUrl: "/assets/images/members/Heads26/AnjanKumar.webp",
    facebookLink: "Anjan_facebook",
    email: "anjan852137@gmail.com",
    linkedinLink: "Anjan_Linkedin"
  }
];

export default Data;